import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=563b331c&scoped=true"
import script from "./UserRegistration.vue?vue&type=script&lang=js"
export * from "./UserRegistration.vue?vue&type=script&lang=js"
import style0 from "./UserRegistration.vue?vue&type=style&index=0&id=563b331c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b331c",
  null
  
)

export default component.exports